import { adaptiveCenterModalOptions } from '@psl/appComponents/ModalWrapper';
import { UserInterfaceIdiomProvider } from '@psl/appComponents/UserInterfaceIdiomContext';
import { OnboardingPostPageHeaderTitle } from '@psl/flows/seller-onboarding/components/OnboardingPostPageHeaderTitle';
import { wrapLazyNavigatorScreen } from '@psl/functions/navigation/utils/wrapNavigatorScreen';
import { CardStyleInterpolators } from '@react-navigation/stack';
import { lazy } from 'react';
import type { ContinuousOnboardingPostItemPageContentProps } from '../components/ContinuousOnboardingPostItemPageContent';

const ContinuousOnboardingPostItemPageContent = lazy(
  () => import('../components/ContinuousOnboardingPostItemPageContent'),
);

export const ContinuousOnboardingPostItemPage = wrapLazyNavigatorScreen(
  (props: ContinuousOnboardingPostItemPageContentProps) => {
    return (
      <UserInterfaceIdiomProvider
        name="continuous-onboarding"
        userInterfaceStyle="light"
      >
        <ContinuousOnboardingPostItemPageContent {...props} />
      </UserInterfaceIdiomProvider>
    );
  },
  ({ route }) =>
    adaptiveCenterModalOptions(isMobile => ({
      headerTitle: OnboardingPostPageHeaderTitle,
      headerLeft: () => null,
      headerRight: () => null,
      headerTitleAlign: 'center',
      title: [route.params.item.title, route.params.item.subTitle]
        .filter(x => x?.trim())
        .join('\n'),
      gestureEnabled: false,
      headerShown: isMobile,
      headerStatusBarHeight: undefined,
      cardStyleInterpolator: CardStyleInterpolators.forModalPresentationIOS,
      cardStyle: isMobile
        ? {
            backgroundColor: 'white',
          }
        : undefined,
    })),
);
